var processInclude = require("base/util");

$(document).ready(function () {
    processInclude(require("./search/search"));
    processInclude(require("./components/contentPlusCarousel"));
    processInclude(require("./components/plpBanner"));
});
